<div class="official-website-home-page">
  <div class="header-title">
    <h1><span>汽车维修技术培训</span></h1>
    <!-- <p>Find the right course for you. Bosch offers training courses tailored to all levels of knowledge and experience.
      Over the last 2 years, we have delivered training courses to more than 4300 participants in the UK and Ireland</p> -->
  </div>
  <!-- <app-scroll-spy-nav [sections]="[
  { id: 'bdx-1', label: 'Our Service Training' },
  { id: 'bdx-2', label: '技术培训' }]">
  </app-scroll-spy-nav> -->
  <!-- <section id="bdx-1" class="equipment-content">
    <div class="service-training-content">
      <h1 class="service-cards-title">Accredited to the highest industry standards</h1>
      <p>Bosch’s range of training courses are industry recognised and accredited: We work to the highest industry
        standards
        and are an IMI approved training provider.</p>
    </div>
  </section> -->
  <section id="bdx-2" class="equipment-content">
    <div class="business-content">
      <div class="business-left">
        <img src="assets/official-website/tech-training.png" alt="bdx-1">
      </div>
      <div class="business-right">
        <h1><span style="display: block;">博世汽车维修技术培训</span>
        </h1>
        <p>
          课程旨在培养专业维修技师找出问题的能力，以更有效的方式诊断和维修车辆，提高产能并减少车主的等待维修时间。
        </p>
        <p><strong>优势：</strong></p>
        <ul class="detail-list">
          <li>
            拥有技术高超、汽车维修经验丰富的资深技术培训讲师团队。
          </li>
          <li>
            提供汽车相关主题的初级、中级及高级技术培训课程。
          </li>
          <li>
            提供实操培训课程，在教室和维修厂之间达成完美平衡。
          </li>
          <li>
            通过小组教学方式，创造专业汽车维修培训环境。
          </li>
        </ul>
      </div>
    </div>
  </section>
</div>